import { RequestResponse, secureRequest, url } from '../utils/request-utils'

type FileImportResponse = {
  id: string
  mimeType: string
}

export function postStagedFile(fileData: string): Promise<RequestResponse<FileImportResponse>> {
  const data = new FormData()
  const b = new Blob([fileData])
  data.append('fileData', b, 'extra-pay.json')
  return secureRequest('POST', url('/v2/stagedFiles/'), {
    body: data,
  })
}
